import { render, staticRenderFns } from "./fullScreenBtn.vue?vue&type=template&id=7372cb84&scoped=true&"
import script from "./fullScreenBtn.vue?vue&type=script&lang=js&"
export * from "./fullScreenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372cb84",
  null
  
)

export default component.exports